export default "__VITE_ASSET__b55ca7da__"